export default __webpack_public_path__ + "static/CentraNo2-Bold-483b2dfbb6930d9becf272e5886c91c9.woff";